var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIndicatorX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3249,-119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard10",
    transform: "matrix(1,0,0,1,-0.0534114,-0.47876)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3249.05,
    y: 119.479,
    width: 92.733,
    height: 92.733,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3249.05,
    y: 119.479,
    width: 92.733,
    height: 92.733
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-17.5682,1239.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3290.46,-1073.56L3271.35,-1092.67C3265.12,-1098.9 3265.12,-1109.02 3271.35,-1115.25C3277.58,-1121.48 3287.7,-1121.48 3293.93,-1115.25L3313.04,-1096.14L3332.15,-1115.25C3338.38,-1121.48 3348.5,-1121.48 3354.73,-1115.25C3360.97,-1109.02 3360.97,-1098.9 3354.73,-1092.67L3335.63,-1073.56L3354.73,-1054.45C3360.97,-1048.22 3360.97,-1038.1 3354.73,-1031.87C3348.5,-1025.63 3338.38,-1025.63 3332.15,-1031.87L3313.04,-1050.97L3293.93,-1031.87C3287.7,-1025.63 3277.58,-1025.63 3271.35,-1031.87C3265.12,-1038.1 3265.12,-1048.22 3271.35,-1054.45L3290.46,-1073.56Z",
    style: {
      fill: "rgb(249,98,99)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3290.46,-1073.56L3271.35,-1092.67C3265.12,-1098.9 3265.12,-1109.02 3271.35,-1115.25C3277.58,-1121.48 3287.7,-1121.48 3293.93,-1115.25L3313.04,-1096.14L3332.15,-1115.25C3338.38,-1121.48 3348.5,-1121.48 3354.73,-1115.25C3360.97,-1109.02 3360.97,-1098.9 3354.73,-1092.67L3335.63,-1073.56L3354.73,-1054.45C3360.97,-1048.22 3360.97,-1038.1 3354.73,-1031.87C3348.5,-1025.63 3338.38,-1025.63 3332.15,-1031.87L3313.04,-1050.97L3293.93,-1031.87C3287.7,-1025.63 3277.58,-1025.63 3271.35,-1031.87C3265.12,-1038.1 3265.12,-1048.22 3271.35,-1054.45L3290.46,-1073.56ZM3305.19,-1073.56L3278.72,-1100.03C3276.55,-1102.2 3276.55,-1105.72 3278.72,-1107.89C3280.88,-1110.05 3284.4,-1110.05 3286.57,-1107.89C3286.57,-1107.89 3313.04,-1081.41 3313.04,-1081.41L3339.51,-1107.89C3341.68,-1110.05 3345.2,-1110.05 3347.37,-1107.89C3349.53,-1105.72 3349.53,-1102.2 3347.37,-1100.03C3347.37,-1100.03 3320.89,-1073.56 3320.89,-1073.56L3347.37,-1047.09C3349.53,-1044.92 3349.53,-1041.4 3347.37,-1039.23C3345.2,-1037.07 3341.68,-1037.07 3339.51,-1039.23C3339.51,-1039.23 3313.04,-1065.71 3313.04,-1065.71L3286.57,-1039.23C3284.4,-1037.07 3280.88,-1037.07 3278.72,-1039.23C3276.55,-1041.4 3276.55,-1044.92 3278.72,-1047.09L3305.19,-1073.56Z",
    style: {
      fill: "rgb(249,98,99)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIndicatorX);
export default __webpack_public_path__ + "static/media/team_indicator_x.e11a8f6bb568c6b19a65e78fe1511c99.svg";
export { ForwardRef as ReactComponent };